import { render, staticRenderFns } from "./misClientes.vue?vue&type=template&id=c952ac0a&"
import script from "./misClientes.vue?vue&type=script&lang=js&"
export * from "./misClientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports